module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parent"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('VTitle', {
    attrs: {
      "page-title": "我的照片"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "scroll",
    staticClass: "photo"
  }, [_c('ul', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    attrs: {
      "infinite-scroll-disabled": "photosInfo.disable",
      "infinite-scroll-immediate-check": "false",
      "infinite-scroll-distance": "50"
    }
  }, [_c('li', _vm._l((_vm.photosInfo.photos), function(obj, index) {
    return _c('img', {
      directives: [{
        name: "tap",
        rawName: "v-tap",
        value: ({
          methods: _vm.click,
          index: index
        }),
        expression: "{methods:click,index:index}"
      }],
      staticClass: "photodetail",
      attrs: {
        "src": obj.image_shrinkage,
        "alt": ""
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.photosInfo.loadingState != 1),
      expression: "photosInfo.loadingState != 1"
    }],
    staticClass: "bottom"
  }, [_c('mt-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.photosInfo.loadingState == 2),
      expression: "photosInfo.loadingState == 2"
    }],
    attrs: {
      "type": "fading-circle",
      "color": "#cba164"
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.loadingText)
    }
  })], 1), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', [_c('VGoBackBtn', {
    on: {
      "exit": _vm.exit
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abc224c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Myrecord/MyPhoto.vue
// module id = 792
// module chunks = 1